import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {repeatTemplatesContainerId} from 'yougile-model'
import {Button} from '@components/common/base/buttons'
import {useSyncEvent} from '@containers/hooks'
import {Help} from '../common/help/help'
import {RepeatEditTemplateRow} from './repeat-edit-template-row'
import {repeatStore} from './repeat-store'

export const RepeatEditTemplateList = observer(() => {
  const bem = Util.bemFrom('repeat-edit')

  useSyncEvent(
    'current',
    {debounceTime: 500, filter: [repeatTemplatesContainerId]},
    () => {
      repeatStore.loadTemplates()
    }
  )

  useEffect(() => {
    repeatStore.loadTemplates()
  }, [repeatStore.state.boardId])

  return (
    <>
      {repeatStore.canEdit && (
        <div className={'flex items-center'}>
          <Button onClick={() => repeatStore.create()} size="small">
            {Lang.msg.repeat.newTemplate}
          </Button>
          <Help name="createRepeatTemplate" className={bem('help')} />
        </div>
      )}
      {!repeatStore.canEdit && (
        <div className={bem('can-edit-warn')}>
          {Lang.msg.repeat.canEditWarn}
        </div>
      )}

      {repeatStore.state.templates.length > 0 && (
        <div className={bem('table')}>
          <div className={bem('row', {header: true})}>
            <div className={bem('col')}>{Lang.msg.repeat.tableName}</div>
            <div className={bem('col')}>{Lang.msg.repeat.tableLoc}</div>
            <div className={bem('col')}>{Lang.msg.repeat.tableConditions}</div>
            <div className={bem('col')}>{Lang.msg.repeat.nearestRepeat}</div>
            <div className={bem('col')}>{Lang.msg.repeat.tableActions}</div>
          </div>

          {repeatStore.state.realTemplates.map(h => (
            <RepeatEditTemplateRow
              key={h.id}
              hub={h}
              isStopped={!h.data.repeatTemplate?.schedule}
            />
          ))}
        </div>
      )}
    </>
  )
})
